import React from 'react';
import { Megaphone } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { gbp } from './shared';

export function SourceSection({ rows }) {
  const total = rows.reduce((a, r) => a + r.billed, 0);
  return (
    <Card className="p-5" data-testid="source-section">
      <div className="flex items-center gap-2 mb-3">
        <Megaphone className="w-5 h-5 text-sky-500" />
        <h2 className="font-bold text-gray-900">Bookings &amp; turnover by source</h2>
        <span className="ml-auto text-xs text-gray-500">"How did you hear about us?" on each booking</span>
      </div>
      {rows.length === 0 ? <p className="text-sm text-gray-500 italic" data-testid="source-empty">No bookings in this window.</p> : (
        <ol className="space-y-2">
          {rows.map((r) => {
            const pct = total > 0 ? Math.round((r.billed / total) * 1000) / 10 : 0;
            return (
              <li key={r.source} className="text-sm" data-testid={`source-row-${r.source}`}>
                <div className="flex items-baseline justify-between gap-3">
                  <span className={`font-semibold truncate ${r.source === 'unknown' ? 'text-gray-500 italic' : 'text-gray-900'}`}>{r.label}</span>
                  <span className="tabular-nums font-bold text-gray-900">{gbp(r.billed)}</span>
                </div>
                <div className="flex items-center gap-2 mt-1">
                  <div className="flex-1 h-2 rounded-full bg-gray-100 overflow-hidden"><div className={`h-full ${r.source === 'unknown' ? 'bg-gray-300' : 'bg-sky-500'}`} style={{ width: `${Math.max(2, pct)}%` }} /></div>
                  <span className="text-[11px] text-gray-500 tabular-nums w-44 text-right">{pct}% · {r.bookings} booking{r.bookings === 1 ? '' : 's'}{r.no_shows ? ` · ${r.no_shows} no-show` : ''}</span>
                </div>
              </li>
            );
          })}
        </ol>
      )}
    </Card>
  );
}
